import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { ButtonType } from '@design-system/components/molecules/button/entities/button.types';
import { Icon, IconFillColor } from '@design-system/components/atoms/icon/entities/icon.types';
import { ButtonIconSize } from '@design-system/components/molecules/button-icon/entities/button-icon.types';
import {
  TypographyColor,
  TypographyFontFamily,
  TypographyFontSize
} from '@design-system/components/atoms/typography/entities/typography.types';
import { ImageSize } from '@design-system/components/molecules/image/entities/image.types';

@Component({
  selector: 'app-modal-gallery',
  templateUrl: './modal-gallery.component.html',
  styleUrls: ['./modal-gallery.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ModalGalleryComponent {

  @Input() images: string[];

  @ViewChild('imagesContent') content: ElementRef;

  public readonly buttonType = ButtonType;
  public readonly buttonIconSize = ButtonIconSize;

  public readonly icon = Icon;
  public readonly iconColor = IconFillColor;

  public readonly fontSize = TypographyFontSize;
  public readonly fontColor = TypographyColor;
  public readonly fontFamily = TypographyFontFamily;

  public imageSize = ImageSize.None;

  public showGallery: boolean = false;
  public currentActiveImage: number = 0;

  constructor(
    private readonly cdr: ChangeDetectorRef,
  ) {}

  get disableNext(): boolean {
    return this.currentActiveImage === (this.images.length - 1);
  }

  get disablePrevious(): boolean {
    return this.currentActiveImage === 0;
  }

  get imagesCount(): string {
    return `${this.currentActiveImage+1}/${this.images?.length}`;
  }

  get selectedImage(): string {
    return this.images?.[this.currentActiveImage];
  }

  public toggleShowGallery(): void {
    this.showGallery = !this.showGallery;
    this.cdr.detectChanges();
  }

  public nextImage(): void {
    if (!this.disableNext) {
      this.currentActiveImage++;
    }
  }

  public previousImage(): void {
    if (!this.disablePrevious) {
      this.currentActiveImage--;
    }
  }

  public selectImage(image: number): void {
    this.currentActiveImage = image;
  }

  public previousImages(): void {
    this.scrollImagesTo(this.content.nativeElement.scrollLeft - 179);
  }

  public nextImages(): void {
    this.scrollImagesTo(this.content.nativeElement.scrollLeft + 179);
  }

  private scrollImagesTo(position: number): void {
    this.content.nativeElement.scrollTo({
      left: position, top: top, behavior: 'smooth'
    });
  }

}
